export const ProfileTabType = {
  Details: "details",
  Edit: "edit",
  Agreements: "agreements",
  Cookies: "cookies",
  Passwords: "pass",
  Facsimile: "facsimile",
};

export const CareerTheme = {
  Visible: "visible",
  Hidden: "hidden",
};
